export enum IPaymentActions {
  BOOK = 'book',
  PAY = 'pay',
  PAY_IN_BUS = 'payInBus',
  REFUND = 'refund'
}